import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const LearningProgressApi = createApi({
  reducerPath: "learningProgress",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getLearningProgress: builder.query({
      query: () => {
        return {
          url: `/learning-path/completeLP`,
          method: "GET"
        };
      },
      extraOptions: { service: "Catalog" }
    }),
    getSocialLearning: builder.query({
      query: () => {
        return {
          url: `/learning-path/socialLearning`,
          method: "GET"
        };
      },
      extraOptions: { service: "Catalog" }
    })
  })
});

export const { useGetLearningProgressQuery, useGetSocialLearningQuery } =
  LearningProgressApi;
